import { getCurrencyExchange } from './v2/get-currency-exchange';
import { getCoupons } from './admin/get-coupons';
import { getGateways } from './admin/get-gateways';
import { getCurrencies } from './admin/get-currencies';
import { searchCoupons } from './admin/search-coupons';

export const paymentsSDK = {
    admin: {
        gateways: {
            get: getGateways,
        },
        currencies: {
            get: getCurrencies,
        },
        coupons: {
            search: searchCoupons,
            get: getCoupons,
        },
    },
    v2: {
        getCurrencyExchange,
    },
};
